import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { ContentBox, TextInput, FormButtons, FormError, InputHint, PortalForm } from '@portal/kit/pkg/components'

const EditPassword = props =>
  <ContentBox title={props.t('account.edit_my_password')}>
    <PortalForm onSubmit={props.handleSubmit}>
      {
        props.submitError && <FormError message={props.submitError} />
      }
      <TextInput name="password" type="password" label={props.t('account.new_password')}>
        <InputHint>{props.t('account.password_complexity_hint')}</InputHint>
      </TextInput>
      <TextInput name="password_confirmation" type="password" label={props.t('account.new_password_confirmation')} />
      <FormButtons cancel="/my-account" submit />
    </PortalForm>
  </ContentBox>

EditPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
}

export default withTranslation()(EditPassword)
